import { type SpacingToken } from '@/theme/tokens';
import { s } from '@/theme/tokens';
import { Box } from './Box';
import type { ReactElement, ReactNode } from 'react';

const SPACING_MAP: Record<SpacingToken, string> = {
  none: s('none'),
  xxxs: s('xxxs'),
  xxs: s('xxs'),
  xs: s('xs'),
  sm: s('sm'),
  md: s('md'),
  lg: s('lg'),
  xl: s('xl'),
  '2xl': s('2xl'),
  '3xl': s('3xl'),
  '4xl': s('4xl'),
  '5xl': s('5xl'),
  gutter: s('gutter'),
  section: s('section'),
};

export type GridProps = {
  columns: string;
  gap?: SpacingToken;
  align?: string;
  children: ReactNode;
};

export const Grid = ({ columns, gap = 'md', align, children }: GridProps): ReactElement => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: columns,
      gap: SPACING_MAP[gap],
      alignItems: align,
      minWidth: 0,
    }}
  >
    {children}
  </Box>
);
